export const buttonVariants = {
  filled: "filled",
  ghost: "ghost",
  icon: "icon",
} as const;
